import { Pipe, PipeTransform } from '@angular/core';

import { ValUtilsService } from '../../services/val-utils.service';

@Pipe({ name: 'deleted' })
export class DeletedPipe implements PipeTransform {
    constructor(private _u: ValUtilsService) { }
    transform(model: Array<any>, trigger: number = 0): any {
        return model && this._u.isArray(model) ? model.filter(x => !x.isDeleted) : model;
    }
}
